import { Component, Input } from '@angular/core';
import { ChecklistService } from '@fi-app/checklist/checklist.service';
import { ChecklistModel } from '@fi-app/checklist/checklist.model';
import { FiLocaleService } from '@fi-shared/fi-locale.service';

@Component({
    selector: 'fi-checklist-report-details',
    templateUrl: './checklist-report-details.component.html',
    styleUrls: ['./checklist-report-details.component.scss'],
    standalone: false,
})
export class ChecklistReportDetailsComponent {
    @Input() checklist: ChecklistModel;

    constructor(
        private checklistService: ChecklistService,
        private localeService: FiLocaleService,
    ) {}

    getTimeSettingsName(id) {
        return this.checklistService.getTimeSettingsName(id);
    }

    getEndDateText() {
        return this.checklistService.getEndDateText(
            this.checklist,
            this.checklist.PublicationSetting.PublicationEndDate,
        );
    }

    isOneTime() {
        return this.checklist.TimeSetting === ChecklistModel.TimeSettings.OneTime;
    }

    isDaily() {
        return this.checklist.RepeatFrequency === ChecklistModel.RepeatFrequency.Daily;
    }

    isMonthly() {
        return this.checklist.RepeatFrequency === ChecklistModel.RepeatFrequency.Monthly;
    }

    showDayOfWeek(hour) {
        return this.checklist.RecurringHours.indexOf(hour) === 0;
    }

    showDueDayOfWeek(hour) {
        return hour + this.checklist.DueTime.Hours >= 24;
    }

    getDayOfWeekName(dayNumber: number, hour?: number) {
        if (hour) {
            // calculate due day
            dayNumber += Math.floor((hour + this.checklist.DueTime.Hours) / 24) + this.checklist.DueTime.Days;
            dayNumber = dayNumber % 7;
        }
        return this.localeService.getDayName(dayNumber);
    }

    showMonth(day) {
        return this.checklist.RecurringDays.indexOf(day) === 0;
    }

    getMonthName(monthNumber: number, day?: number, isLeapYear?: boolean) {
        if (!day) {
            return this.localeService.getMonthName(monthNumber - 1);
        }
        const dueDate = this.getDueDate(monthNumber, day, isLeapYear);
        return this.localeService.getMonthName(dueDate.month - 1);
    }

    getMonthDueDay(monthNumber: number, day: number, isLeapYear?: boolean) {
        const dueDate = this.getDueDate(monthNumber, day, isLeapYear);
        return dueDate.day;
    }

    showDueMonth(monthNumber, day) {
        const dueDate = this.getDueDate(monthNumber, day);
        return monthNumber !== dueDate.month;
    }

    showLeapYearInfo(monthNumber, day) {
        const dueDate = this.getDueDate(monthNumber, day);
        const leapYearDueDate = this.getDueDate(monthNumber, day, true);
        return dueDate.day !== leapYearDueDate.day || dueDate.month !== leapYearDueDate.month;
    }

    private getDueDate(monthNumber, day, isLeapYear?) {
        const year = isLeapYear ? 2016 : 2017;
        const date = new Date(year, monthNumber - 1, day);
        date.setMonth(date.getMonth() + this.checklist.DueTime.Months);
        date.setDate(date.getDate() + this.checklist.DueTime.Days);
        return {
            month: date.getMonth() + 1,
            day: date.getDate(),
        };
    }
}
